import {TimestampableInterface} from '../../../shared/models/ressources/timestampable.interface';
import {Produit} from '../produit/produit.model';

export interface ArticleInterface extends TimestampableInterface {
    id?: number;
    libelle?: string;
    dateDebut?: Date | null;
    dateFin?: Date | null;
    dateDebutVente?: Date | null;
    dateFinVente?: Date | null;
    nominatif?: boolean | null;
    sellable?: boolean | null;
    produit?: Produit | null;
    prixPublic?: string | null;
    prixVente?: string | null;
    prixSubvention?: string | null;
    generique?: boolean | null;
    stockReel?: number | null;
    optionGroupe?: boolean | null;
    nombreOptionGroupe?: number | null;
    usrcre?: number | null;
    usrmaj?: number | null;
    images?: object | null;
    rsfType?: string | null;
    rsfAppliquerPlafondFacture: boolean | null;
    rsfAppliquerPlafondRemboursementFacture: boolean | null;
    rsfAppliquerPlafondRemboursementUnite: boolean | null;
    rsfAppliquerPlafondUnite: boolean | null;
    rsfLibelleUniteDecompte: string | null;
    rsfLibelleUniteDecomptePluriel: string | null;
    rsfLibelleUnitePresentee: string | null;
    rsfLibelleUnitePresenteePluriel: string | null;
    rsfMessage: string | null;
    rsfPlafondFactureAgeMaxEnfant: number | null;
    rsfPlafondFactureAgeMinEnfant: number | null;
    rsfPlafondFactureConjoint: number | null;
    rsfPlafondFactureEnfant: number | null;
    rsfPlafondFactureEnfantACharge: number | null;
    rsfPlafondFactureEnfantDirect: number | null;
    rsfPlafondFactureMax: number | null;
    rsfPlafondFactureOD: number | null;
    rsfPlafondFactureQuePorteur: boolean | null;
    rsfPlafondRemboursementFacture: number | null;
    rsfPlafondRemboursementUnite: string | null;
    rsfPlafondUnite: string | null;
    notSellableMessage?: string | null;
    restockage?: boolean;
}

export namespace ArticleType {
    export type TypeEnum = 'UNITE' | 'FACT' | 'MANU';
    export const TypeEnum = {
        Unite: 'UNITE' as TypeEnum,
        Facture: 'FACT' as TypeEnum,
        Manuel: 'MANU' as TypeEnum
    };

    export type AChargeEnum = 'TOUS' | 'OUI' | 'NON';
    export const AChargeEnum = {
        Tous: 'TOUS' as AChargeEnum,
        Oui: 'OUI' as AChargeEnum,
        Non: 'NON' as AChargeEnum
    };

    export type DirectEnum = 'TOUS' | 'OUI' | 'NON';
    export const DirectEnum = {
        Tous: 'TOUS' as DirectEnum,
        Oui: 'OUI' as DirectEnum,
        Non: 'NON' as DirectEnum
    };
}



// WEBPACK FOOTER //
// ./src/shared/models/article/article.interface.ts